import { ReactElement } from 'react';
import ConfirmationModal from '../../molecules/ConfirmationModal/ConfirmationModal';
import { TAspect } from '../../../lib/types';

type Props<T extends TAspect> = {
  aspectName: string;
  selection: T[];
  onSubmit: (selection: T[]) => Promise<unknown>;
  renderButton: (onClick: () => void) => ReactElement;
};

const DeleteConfirmationModal = <T extends TAspect>({
  aspectName,
  selection,
  onSubmit,
  renderButton,
}: Props<T>) => {
  return (
    <ConfirmationModal
      title={`Remove ${aspectName}`}
      message={`Are you sure you want to remove the selected item${selection.length > 1 ? 's' : ''}?`}
      confirmButtonText="Confirm"
      cancelButtonText="Cancel"
      onConfirm={async () => onSubmit(selection)}
      renderButton={renderButton}
    />
  );
};

export default DeleteConfirmationModal;
